import { Component, Inject, Injector, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { DialogData } from 'app/core/interfaces/dialog';
import { Practitioner,  } from 'app/core/interfaces/practitioner';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { skip } from 'rxjs';

@Component({
  selector: 'src-create-practitioner',
  templateUrl: './create-practitioner.component.html',
  styleUrls: ['./create-practitioner.component.css']
})
export class CreatePractitionerComponent extends BaseComponent implements OnInit {

  public titles = ['Meus dados', 'Endereço', 'Horários', 'Dados profissionais'];
    public practitionerRole: any
    public mode = 'CREATE';
    public submittedPaymentSettings = false;
    public sucessPaymentSettings = false;
    public isSavingSettings = false;
    activeTabIndex = 0;
    public practitioner !: Practitioner
  
    public selectedTabIndex = 0
    public practitioner_id: string = ""
  
  
  
    alerts: string[] = [];
  
  
    constructor(
      private fb: FormBuilder,
      private injector: Injector,
      private route: ActivatedRoute,
      @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {
      super(injector)

    }
  
    ngOnInit(): void {

      if (this.data?.param?.mode == "UPDATE"){
        this.mode = "UPDATE"
        this.practitioner_id = this.data.param.practitioner.practitioner_id
      }

      this.listenToTabQueryParam()

    }
  


    private resolveInitialTabIndex(): number {
      const tabName = localStorage.getItem('tabAfterReload') ?? 'perfil';
      localStorage.removeItem('tabAfterReload');
  
      return this.getTabIndexByName(tabName);
    }
  
    private listenToTabQueryParam(): void {
      this.route.queryParams
        .subscribe((params) => {
          const tabName = params['tab'];
  
          if (tabName) {
            const index = this.getTabIndexByName(tabName);
  
          
            this.setTabIfAllowed(index);
            
          }
  
        });
    }
  
    private setTabIfAllowed(index: number): void {
      console.log("table allow", this.isTabAllowed(index))
      if (this.isTabAllowed(index)) {
        this.selectedTabIndex = index;
      }
    }

    checkIfIsFirstAccess(){
      return true
    }
  
    private isTabAllowed(index: number): boolean {
      return  index > 0;
    }
  
    onTabChange(event: MatTabChangeEvent): void {
      const tabName = this.getTabNameByIndex(event.index);
  
      this.router.navigate([], {
        queryParams: { tab: tabName },
        queryParamsHandling: 'merge'
      });
    }
  
    getTabIndexByName(tabName: string): number {
      switch (tabName) {
        case 'perfil':
          return 0;
        case 'especialidade':
          return 1;
        case 'qualificacao':
          return 2
        default:
          return 0;
      }
    }
  
    getTabNameByIndex(index: number): string {
      switch (index) {
        case 0:
          return 'perfil';
        case 1:
          return 'especialidade'
        case 2:
          return 'qualificacao';
        case 3:
          return 'localizacao';
        default:
          return 'perfil';
      }
    }
  
    public setPractitioner(practitioner: any) {
      this.practitioner = practitioner

  
  
      this.showWarningMessage = true
  
    }
  
    public setPractitionerRole(practitionerRole: any) {
      this.practitionerRole = practitionerRole

      if (this.objectIsEmpty(practitionerRole)) {
        this.showWarningMessage = true
      }
    }
  
    allowOnlyLetters(event: KeyboardEvent): void {
      const inputChar = event.key;
      if (!/^[a-zA-ZÀ-ÿ\s]$/.test(inputChar)) {
        event.preventDefault();
      }
    }
  
    allowOnlyNumbers(event: KeyboardEvent): void {
      const inputChar = event.key;
      if (!/^\d$/.test(inputChar)) {
        event.preventDefault();
      }
    }
  
    allowAgencyInput(event: KeyboardEvent): void {
      const inputChar = event.key;
      const input = (event.target as HTMLInputElement).value;
      if (!/^\d$/.test(inputChar) || input.length >= 4) {
        event.preventDefault();
      }
    }
  
    allowAccountInput(event: KeyboardEvent): void {
      const inputChar = event.key;
      const input = (event.target as HTMLInputElement).value;
      if (!/^[0-9\-]$/.test(inputChar) || input.length >= 9) {
        event.preventDefault();
      }
    }
  
    allowCpfInput(event: KeyboardEvent): void {
      const inputChar = event.key;
      const input = (event.target as HTMLInputElement).value;
      if (!/^[0-9.\-]$/.test(inputChar) || input.length >= 14) {
        event.preventDefault();
      }
    }
  
    allowCnpjInput(event: KeyboardEvent): void {
      const inputChar = event.key;
      const input = (event.target as HTMLInputElement).value;
      if (!/^[0-9./\-]$/.test(inputChar) || input.length >= 18) {
        event.preventDefault();
      }
    }
  
    allowPhoneInput(event: KeyboardEvent): void {
      const inputChar = event.key;
      const input = (event.target as HTMLInputElement).value;
      if (!/^[0-9()+\s\-]$/.test(inputChar) || input.length >= 15) {
        event.preventDefault();
      }
    }
  
    allowEmailInput(event: KeyboardEvent): void {
      const inputChar = event.key;
      const input = (event.target as HTMLInputElement).value;
      if (!/^[a-zA-Z0-9@._\-]$/.test(inputChar) || input.length >= 254) {
        event.preventDefault();
      }
    }
  

    objectIsEmpty(obj?: any): boolean {
  
      if (obj == null) return true;
  
      if (Array.isArray(obj)) {
        return obj.length === 0;
      }
  
      if (typeof obj === 'object') {
        const values = Object.values(obj);
        return values.every(
          v =>
            v === null ||
            v === undefined ||
            (typeof v === 'string' && v.trim() === '')
        );
      }
  
      return false;
    }

}



